// pages/Register/index.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { authService } from "../../services/auth.service";
import { Button } from "../../styles/components";
import {
	RegisterWrapper,
	RegisterCard,
	Logo,
	Form,
	FormGroup,
	Label,
	Input,
	ErrorMessage,
	LoginLink,
} from "./styles";

const Register = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		password: "",
		confirmPassword: "",
		phone: "",
	});
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");

		// Validate passwords match
		if (formData.password !== formData.confirmPassword) {
			setError("Passwords do not match");
			return;
		}

		// Validate password strength
		if (formData.password.length < 6) {
			setError("Password must be at least 6 characters");
			return;
		}

		setLoading(true);

		try {
			await authService.register(formData.email, formData.password, {
				name: formData.name,
				phone: formData.phone,
			});

			toast.success("Registration successful!", {
				style: {
					padding: "1rem",
				},
			});
			navigate("/dashboard");
		} catch (err) {
			console.error("Registration error:", err);
			setError(err.message || "Failed to register. Please try again.");
			toast.error("Registration failed. Please try again.", {
				style: { padding: "1rem" },
			});
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (e) => {
		setFormData((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};

	return (
		<RegisterWrapper>
			<RegisterCard
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6 }}
			>
				<Logo>
					<h1>Create Account</h1>
				</Logo>

				<Form onSubmit={handleSubmit}>
					<FormGroup>
						<Label htmlFor="name">Full Name</Label>
						<Input
							type="text"
							id="name"
							name="name"
							value={formData.name}
							onChange={handleChange}
							required
							autoComplete="name"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="email">Email</Label>
						<Input
							type="email"
							id="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							required
							autoComplete="email"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="phone">Phone Number</Label>
						<Input
							type="tel"
							id="phone"
							name="phone"
							value={formData.phone}
							onChange={handleChange}
							required
							autoComplete="tel"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="password">Password</Label>
						<Input
							type="password"
							id="password"
							name="password"
							value={formData.password}
							onChange={handleChange}
							required
							autoComplete="new-password"
						/>
					</FormGroup>

					<FormGroup>
						<Label htmlFor="confirmPassword">Confirm Password</Label>
						<Input
							type="password"
							id="confirmPassword"
							name="confirmPassword"
							value={formData.confirmPassword}
							onChange={handleChange}
							required
							autoComplete="new-password"
						/>
					</FormGroup>

					{error && <ErrorMessage>{error}</ErrorMessage>}

					<Button type="submit" disabled={loading} size="large">
						{loading ? "Creating Account..." : "Create Account"}
					</Button>
				</Form>

				<LoginLink>
					Already have an account? <Link to="/login">Sign in</Link>
				</LoginLink>
			</RegisterCard>
		</RegisterWrapper>
	);
};

export default Register;
